/** The admin area's sections, in order. The column lists them; the admin layout names the open one. */
export const ADMIN_SECTIONS = [
  { to: "/admin/topics", label: "Topics" },
  { to: "/admin/templates", label: "Templates" },
  { to: "/admin/gorelo", label: "Gorelo" },
  { to: "/admin/themes", label: "Themes" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/tokens", label: "API tokens" },
  { to: "/admin/audit", label: "Audit log" },
] as const;
